import { Linking } from 'react-native';
import { useNavigate } from 'react-router-native';
interface OpenLinkProps {
  link: string;
  newTab?: boolean;
}
export const useOpenLink = () => {
  const navigate = useNavigate();

  const openLink = function ({ link, newTab = false }: OpenLinkProps) {
    if (!link) {
      return;
    }
    if (!newTab && link.charAt(0) === '/') {
      navigate(link);
    } else {
      Linking.openURL(link);
    }
  };
  return { openLink };
};
